module.exports = __webpack_public_path__ + "assets/img/ztsy.a24ef21a.png";